const PERMISSION_KEY= "personalize:user_screener";
const PAGE_URL = {
    USER_SCREENER_PAGE: "/admin/personalize/user-screener"
}

export {PERMISSION_KEY, PAGE_URL}

